if (window.location.href.indexOf('/collections/vendors?q=Activist') > -1){ 
    window.location.href='/collections/activist-manuka';
}
if (window.location.href.indexOf('/collections/vendors?q=Aesop') > -1){ 
    window.location.href='/collections/aesop';
}
if (window.location.href.indexOf('/collections/vendors?q=Ancient') > -1){ 
    window.location.href='/collections/ancient-brave';
}
if (window.location.href.indexOf('/collections/vendors?q=Apoem') > -1){ 
    window.location.href='/collections/apoem';
}
if (window.location.href.indexOf('/collections/vendors?q=Augustinus') > -1){ 
    window.location.href='/collections/augustinus-bader';
}
if (window.location.href.indexOf('/collections/vendors?q=BDK') > -1){ 
    window.location.href='/collections/bdk-parfums';
}
if (window.location.href.indexOf('/collections/vendors?q=Byredo') > -1){ 
    window.location.href='/collections/byredo';
}
if (window.location.href.indexOf('/collections/vendors?q=Coola') > -1){ 
    window.location.href='/collections/coola';
}
if (window.location.href.indexOf('/collections/vendors?q=Dariia') > -1){ 
    window.location.href='/collections/dariia-day';
}
if (window.location.href.indexOf('/collections/vendors?q=Diamancel') > -1){ 
    window.location.href='/collections/diamancel';
}
if (window.location.href.indexOf('/collections/vendors?q=Diptyque') > -1){ 
    window.location.href='/collections/diptyque';
}
if (window.location.href.indexOf('/collections/vendors?q=Dr.') > -1){ 
    window.location.href='/collections/dr-barbara-sturm';
}
if (window.location.href.indexOf('/collections/vendors?q=Dr.%20Barbara') > -1){ 
    window.location.href='/collections/dr-barbara-sturm';
}
if (window.location.href.indexOf('/collections/vendors?q=Endor') > -1){ 
    window.location.href='/collections/endor-technologies';
}
if (window.location.href.indexOf('/collections/vendors?q=Escentric') > -1){ 
    window.location.href='/collections/escentric-molecules';
}
if (window.location.href.indexOf('/collections/vendors?q=Gold') > -1){ 
    window.location.href='/collections/gold-collagen';
}
if (window.location.href.indexOf('/collections/vendors?q=Heeley') > -1){ 
    window.location.href='/collections/heeley';
}
if (window.location.href.indexOf('/collections/vendors?q=Hierbas') > -1){ 
    window.location.href='/collections/hierbas-de-ibiza';
}
if (window.location.href.indexOf('/collections/vendors?q=Jao') > -1){ 
    window.location.href='/collections/jao-brand';
}
if (window.location.href.indexOf('/collections/vendors?q=Juice') > -1){ 
    window.location.href='/collections/juice-beauty';
}
if (window.location.href.indexOf('/collections/vendors?q=Le') > -1){ 
    window.location.href='/collections/le-prunier';
}
if (window.location.href.indexOf('/collections/vendors?q=Maison') > -1){ 
    window.location.href='/collections/maison-crivelli';
}
if (window.location.href.indexOf('/collections/vendors?q=Malin') > -1){ 
    window.location.href='/collections/malin-goetz';
}
if (window.location.href.indexOf('/collections/vendors?q=Manta') > -1){ 
    window.location.href='/collections/manta';
}
if (window.location.href.indexOf('/collections/vendors?q=Mason') > -1){ 
    window.location.href='/collections/mason-pearson';
}
if (window.location.href.indexOf('/collections/vendors?q=Matiere') > -1){ 
    window.location.href='/collections/matiere-premiere';
}
if (window.location.href.indexOf('/collections/vendors?q=May') > -1){ 
    window.location.href='/collections/may-lindstorm';
}
if (window.location.href.indexOf('/collections/vendors?q=Nasomatto') > -1){ 
    window.location.href='/collections/nasomatto';
}
if (window.location.href.indexOf('/collections/vendors?q=Per') > -1){ 
    window.location.href='/collections/per-purr';
}
if (window.location.href.indexOf('/collections/vendors?q=Rahua') > -1){ 
    window.location.href='/collections/rahua';
}
if (window.location.href.indexOf('/collections/vendors?q=Revitalash') > -1){ 
    window.location.href='/collections/revitalash';
}
if (window.location.href.indexOf('/collections/vendors?q=Sepai') > -1){ 
    window.location.href='/collections/sepai';
}
if (window.location.href.indexOf('/collections/vendors?q=Susanne') > -1){ 
    window.location.href='/collections/susanne-kaufmann';
}
if (window.location.href.indexOf('/collections/vendors?q=Tata') > -1){ 
    window.location.href='/collections/tata-harper';
}
if (window.location.href.indexOf('/collections/vendors?q=Tweezerman') > -1){ 
    window.location.href='/collections/tweezerman';
}
if (window.location.href.indexOf('/collections/vendors?q=Twelve') > -1){ 
    window.location.href='/collections/twelve-beauty';
}
if (window.location.href.indexOf('/collections/vendors?q=U%20Beauty') > -1){ 
    window.location.href='/collections/u-beauty';
}
if (window.location.href.indexOf('/collections/vendors?q=U+Beauty') > -1){ 
    window.location.href='/collections/u-beauty';
}
if (window.location.href.indexOf('/collections/vendors?q=Vintner') > -1){ 
    window.location.href='/collections/vintners-daughter';
}
if (window.location.href.indexOf('/collections/vendors?q=WelleCo') > -1){ 
    window.location.href='/collections/welle-co';
}
if (window.location.href.indexOf('/collections/vendors?q=Westman') > -1){ 
    window.location.href='/collections/westman-atelier';
}
if (window.location.href.indexOf('/collections/vendors?q=Zwilling') > -1){ 
    window.location.href='/collections/zwilling';
}
if (window.location.href.indexOf('/collections/vendors?q=2787') > -1){ 
    window.location.href='/collections/2787-perfumes';
}

